/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from native/schemas/document/PageData.yaml
import { DocumentDetectionStatusValues } from '../document_scanner/DocumentScannerTypes';
import { PageImageSourceValues } from '../document_scanner/PageImageSource';
import { DocumentQualityValues } from '../dqa/DocumentQualityAnalyzerTypes';
import { ParametricFilter } from '../image_filters/ParametricFilters';
import { ToJsonConfiguration } from '../utils/json/JsonSerializationTypes';
import { PartiallyConstructible } from '../utils/utils';
/**
The result of the health insurance card recognition.
*/
export class PageData extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<PageData>`} */
    constructor(source = {}) {
        super();
        /**
          The list of filters applied to the page.
          */
        this.filters = null;
        /**
          The polygon of the page.
          */
        this.polygon = [];
        /**
          The detection status of the page.
          */
        this.documentDetectionStatus = null;
        /**
          The quality score of the page.
          */
        this.documentQuality = null;
        /**
          The source of the page image.
          */
        this.source = null;
        /**
          The URI of the document image.
          */
        this.documentImageURI = null;
        /**
          The URI of the unfiltered document image.
          */
        this.unfilteredDocumentImageURI = null;
        /**
          The URI of the document image preview.
          */
        this.documentImagePreviewURI = null;
        if (source.uuid !== undefined) {
            this.uuid = source.uuid;
        }
        else {
            throw new Error('uuid must be present in constructor argument');
        }
        if (source.filters !== undefined) {
            this.filters =
                source.filters != null
                    ? source.filters.map((it) => {
                        return ParametricFilter.From(it);
                    })
                    : null;
        }
        if (source.polygon !== undefined) {
            this.polygon = source.polygon.map((it) => {
                return { x: it.x, y: it.y };
            });
        }
        if (source.documentDetectionStatus !== undefined) {
            this.documentDetectionStatus =
                source.documentDetectionStatus != null
                    ? DocumentDetectionStatusValues.includes(source.documentDetectionStatus)
                        ? source.documentDetectionStatus
                        : null
                    : null;
        }
        if (source.documentQuality !== undefined) {
            this.documentQuality =
                source.documentQuality != null
                    ? DocumentQualityValues.includes(source.documentQuality)
                        ? source.documentQuality
                        : null
                    : null;
        }
        if (source.source !== undefined) {
            this.source =
                source.source != null ? (PageImageSourceValues.includes(source.source) ? source.source : null) : null;
        }
        if (source.originalImageURI !== undefined) {
            this.originalImageURI = source.originalImageURI;
        }
        else {
            throw new Error('originalImageURI must be present in constructor argument');
        }
        if (source.documentImageURI !== undefined) {
            this.documentImageURI = source.documentImageURI != null ? source.documentImageURI : null;
        }
        if (source.unfilteredDocumentImageURI !== undefined) {
            this.unfilteredDocumentImageURI =
                source.unfilteredDocumentImageURI != null ? source.unfilteredDocumentImageURI : null;
        }
        if (source.documentImagePreviewURI !== undefined) {
            this.documentImagePreviewURI = source.documentImagePreviewURI != null ? source.documentImagePreviewURI : null;
        }
    }
    serialize(config = new ToJsonConfiguration()) {
        return {
            uuid: this.uuid,
            filters: this.filters != null
                ? this.filters.map((it) => {
                    return it.serialize(config);
                })
                : null,
            polygon: this.polygon.map((it) => {
                return it;
            }),
            documentDetectionStatus: this.documentDetectionStatus != null ? this.documentDetectionStatus : null,
            documentQuality: this.documentQuality != null ? this.documentQuality : null,
            source: this.source != null ? this.source : null,
            originalImageURI: this.originalImageURI,
            documentImageURI: this.documentImageURI != null ? this.documentImageURI : null,
            unfilteredDocumentImageURI: this.unfilteredDocumentImageURI != null ? this.unfilteredDocumentImageURI : null,
            documentImagePreviewURI: this.documentImagePreviewURI != null ? this.documentImagePreviewURI : null,
        };
    }
}
//# sourceMappingURL=PageData.js.map